import { render, staticRenderFns } from "./PMStructureCreateFolderModal.vue?vue&type=template&id=330477e9&"
import script from "./PMStructureCreateFolderModal.vue?vue&type=script&lang=ts&"
export * from "./PMStructureCreateFolderModal.vue?vue&type=script&lang=ts&"
import style0 from "./PMStructureCreateFolderModal.vue?vue&type=style&index=0&id=330477e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports